import React, { useState, useEffect } from 'react';
import {
  Spin, Button, Card, Tag, message, Tooltip, Input, Modal, Space, Table
} from 'antd';
import {
  EditOutlined,
  StopOutlined,
  CheckOutlined
} from '@ant-design/icons';
import 'antd/dist/antd.css';
import Fuse from 'fuse.js';
import _ from 'lodash';
import moment from 'moment';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import * as Service from '../core/Service';
import { ActionCreators } from '../redux/actions';
import NavAndSideFrame from '../components/NavAndSideFrame';
import AdminForm from '../components/AdminForm';
import { useTranslation } from 'react-i18next';
import { displayIsActive } from '../components/table/DisplayMethod';

const title = `管理員列表`;
const selectedKey = `admin_list`;
const tableIdName = `admin_id`;
const filterableField = [
  'email',
  'nickname',
  'mobile'
];
const defaultFormData = {
  password: undefined,
  email: undefined,
  mobile: undefined,
  nickname: undefined,
  is_active: undefined
}

const AdminList = (props) => {
  const {t} = useTranslation();

  const [dataList, setDataList] = useState([]);
  const [unChangeData, setUnChangeData] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState({});
  const [isShowPassword, setShowPassword] = useState(false);
  const [isChangingIsActive, setChangingIsActive] = useState(false);
  const [loading, setLoading] = useState(false);

  const {
    app
  } = props;

  useEffect(() => {
    getAllData();
  }, []);

  const getAllData = async () => {
    let endpoint = `/api/admin/list`;
    let list = [];
    setLoading(true);
    try {
      let data = await Service.call(`GET`, endpoint);
      list = _.orderBy(data, [`ctime`], [`desc`]);
      if (data.errorMessage) list = [];
    } catch (error) {
      console.log(error);
    } finally {
      setDataList(list);
      setUnChangeData(list);
      setLoading(false);
    }
  }

  const setTableHeader = () => {
    let columns = [
      {
        title: '操作',
        dataIndex: tableIdName,
        render: (value, record) => {
          return (
            <span>
              <Tooltip title={t('common.edit')}>
                <Button
                  shape="circle"
                  style={{ marginRight: 8, color: '#000000' }}
                  icon={<EditOutlined />}
                  onClick={() => {
                    if (app.admin.admin_id === record.admin_id) {
                      setShowPassword(true);
                    } else {
                      setShowPassword(false);
                    }
                    setSelectedRecord(record);
                    setModalVisible(true);
                  }}
                />
              </Tooltip>
              <Tooltip title={record.is_active ? t('admin.disable_admin') : t('admin.enable_admin')}>
                <Button
                  shape="circle"
                  style={{ color: record.is_active ? 'red' : 'green' }}
                  icon={record.is_active ? (<StopOutlined />) : (<CheckOutlined />)}
                  onClick={async () => {
                    if (isChangingIsActive) return; // avoid multiple attempts

                    setChangingIsActive(true);
                    let { admin_id, is_active } = record;
                    is_active = !is_active;

                    let result = await Service.call('put', `/api/admin`, { admin_id, is_active });
                    setChangingIsActive(false);

                    if (_.isEmpty(result) || result.status < 1) {
                      return message.error(is_active ? t('admin.enable_failed') : t('admin.disable_failed'));
                    }
                    await getAllData();
                    return message.success(is_active ? t('admin.enabled_admin') : t('admin.disabled_admin'));
                  }}
                />
              </Tooltip>
            </span>
          )
        }
      },
      { title: '管理員編號', dataIndex: tableIdName },
      {
        title: '生效狀態',
        dataIndex: 'is_active',
        render: (value) => {
          return displayIsActive(value, t);
        },
        ellipsis: true
      },
      { title: `電郵`, dataIndex: `email` },
      { title: `暱稱`, dataIndex: `nickname` },
      { title: `手提號碼`, dataIndex: `mobile` },
      {
        title: '創建時間',
        dataIndex: 'ctime',
        render: (value) => {
          return displayMoment(value);
        },
        ellipsis: true,
      },
      {
        title: '更新時間',
        dataIndex: 'utime',
        render: (value) => {
          return displayMoment(value);
        },
        ellipsis: true,
      },

    ];
    return columns;
  }

  const displayMoment = (unixTime, outputFormat = 'YYYY/MM/DD HH:mm') => {
    if (unixTime !== 0) {
      let displayTime = moment.unix(unixTime).format(outputFormat);
      return displayTime;
    }
    return '-';
  }

  const getDataBySearchKeyword = (keywords) => {
    let dataList = [];
    try {
      const options = {
        includeScore: true,
        findAllMatches: true,
        threshold: 0.15,
        keys: filterableField
      }
      const fuse = new Fuse(unChangeData, options)
      const result = fuse.search(keywords);
      console.log("RESULT", result);
      dataList = _.map(result, 'item');
      dataList = _.orderBy(dataList, [`ctime`], [`desc`]);
    } catch (error) {
      console.error('error >>> ', error);
    } finally {
      setDataList(dataList);
    }
  }

  let timeout;
  const debounce = (func, delay) => {
    clearTimeout(timeout);
    timeout = setTimeout(func, delay);
  };

  const onChange = (keyword) => {
    debounce(() => {
      getDataBySearchKeyword(keyword);
      if (_.isEmpty(keyword)) setDataList(unChangeData);
    }, 400);
  };

  return (
    <NavAndSideFrame {...props} title={title} selectedKey={selectedKey}>
      <Card>
        <Button
          icon={<EditOutlined />}
          style={{ marginRight: 10 }}
          type="primary"
          onClick={() => {
            setSelectedRecord(defaultFormData);
            setShowPassword(true);
            setModalVisible(true);
          }}
        >
          新增
        </Button>

        <Space direction="horizontal">
          <>以文字搜尋:</>
          <Input
            placeholder="請輸入文字"
            onChange={(values) => {
              onChange(values.target.value);
            }}
          />
        </Space>
      </Card>

      <Card>
        <Spin spinning={loading}>
          <Table
            pagination={{
              defaultPageSize: 25,
              showSizeChanger: true,
              pageSizeOptions: [25, 50, 100, 200, 500]
            }}

            scroll={{ x: `max-content` }}
            dataSource={dataList}
            columns={setTableHeader()}
            rowKey={tableIdName}
          />
        </Spin>
      </Card>
      <Modal
        title={t("admin.admin")}
        visible={modalVisible}
        footer={null}
        style={{ maxWidth: 800 }}
        width="90%"
        onCancel={() => { setModalVisible(false) }}
        destroyOnClose
      >
        <AdminForm
          selectedRecord={selectedRecord}
          isShowPassword={isShowPassword}
          openModal={(value) => {
            getAllData();
            setModalVisible(value);
          }}
        />
      </Modal>

    </NavAndSideFrame>
  );
}

// export default AdminList;

function mapStateToProps(state) {
  return {
    app: state.app
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminList);